import { render, staticRenderFns } from "./ManageBatchAndAccountingGroups.vue?vue&type=template&id=d2df295a&scoped=true"
import script from "./ManageBatchAndAccountingGroups.vue?vue&type=script&lang=js"
export * from "./ManageBatchAndAccountingGroups.vue?vue&type=script&lang=js"
import style0 from "./ManageBatchAndAccountingGroups.vue?vue&type=style&index=0&id=d2df295a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2df295a",
  null
  
)

export default component.exports